import { render, staticRenderFns } from "./MenstruumMaster.vue?vue&type=template&id=95994984"
import script from "./MenstruumMaster.vue?vue&type=script&lang=js"
export * from "./MenstruumMaster.vue?vue&type=script&lang=js"
import style0 from "./MenstruumMaster.vue?vue&type=style&index=0&id=95994984&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports